import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import InstagramIcon from "../../assets/svg/InstagramIcon";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80} style={{gap: "5px"}} rel="nofollow">
              <img src="/logo-key.png" width={35} height={35} alt="Chave" />
              <WrapperText>
                <h1 className="font15 extraBold whiteColor">
                  Chaveiro 24hrs
                </h1>
                <h2 className="font12 whiteColor">
                  Desde 1986
                </h2>
              </WrapperText>
            </Link>
            <AnchorLinkedin href="https://www.linkedin.com/in/marceloamonteiro/" target="_blank" rel="noreferrer">
              <p className="font13 whiteColor">
                © {getCurrentYear()} - Marcelo A. Monteiro
              </p>  
            </AnchorLinkedin>
            <div>
              <AnchorInstagram href="https://www.instagram.com/chaveiro.24hcentro/" target="_blank" rel="noreferrer">
                <InstagramIcon />
                <p className="font13 whiteColor">
                  @chaveiro.24hcentro
                </p>
              </AnchorInstagram>
            </div>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin: 130px 0 0;

  @media (max-width: 860px) {
    margin: 50px 0 0;
  }
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const AnchorLinkedin = styled.a`
  @media (max-width: 550px) {
    margin: 10px 0;
    order: 1;
  }
`;
const WrapperText = styled.div`
  line-height: 17px;

  @media (max-width: 550px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    line-height: 15px;

    > h1 {
      font-size: 0.813rem;
    }
    > h2 {
      font-size: 0.688rem;
    }
  }
`
const AnchorInstagram = styled.a`
  display: flex;
  align-items: center;
  text-decoration: unset;
  gap: 3px;

  @media (max-width: 550px) {
    margin: 11px 0 5px;
  }
`